var concertBox = function () {
    var init = function () {
        if ($('.concerts-list__concerts').length !== 0) {
            $('.concerts-list__concert').each(function () {
                var $this = $(this),
                        concertBox = $('.concert-box'),
                        imagePath = $this.data('image'),
                        imageBox = concertBox.find('.concert-box__image'),
                        date = concertBox.find('.concert-box__date'),
                        price = concertBox.find('.concert-box__price'),
                        place = concertBox.find('.concert-box__place'),
                        offset = $this[0].offsetLeft;

                $this.hover(function (e) {
                    imageBox.css('background-image', 'url("' + imagePath + '")');
                    date.text($this.data('date'));
                    price.text($this.data('price'));
                    place.text($this.data('place'));
                    concertBox.css({
                        'top': $this.position().top - 50,
                        'left': offset - 500,
                    })
                }, function () {
                    concertBox.css('left', '-9999px');
                });
            });
        }
    }

    return {
        init: function () {
            init();
        }
    };
}();

$(document).ready(function () {
    concertBox.init();
});